import { rest } from 'msw';
import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './unpaidAmoutAndUsedbytes.json';

const queryUnpaidAmoutAndUsedbytes = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['unpaidAmoutAndUsedbytesController/queryUnpaidAmoutAndUsedbytes'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('unpaidAmoutAndUsedbytesController/queryUnpaidAmoutAndUsedbytes'),
    withScenario(withAuthCheck(queryUnpaidAmoutAndUsedbytes))
  ),
];
